(function () {
  const desktop = window.matchMedia('(min-width: 990px)');

  function wheelDelta(event) {
    return event.deltaMode === 1 ? event.deltaY * 16 : event.deltaY;
  }

  function columnState(column) {
    const maxScroll = column.scrollHeight - column.clientHeight;
    return {
      atTop: column.scrollTop <= 0,
      atBottom: maxScroll <= 1 || column.scrollTop >= maxScroll - 1,
    };
  }

  function scrollBy(column, delta) {
    column.scrollTop += delta;
  }

  function bind(root) {
    if (!root || root.dataset.splitScrollBound) return;
    root.dataset.splitScrollBound = 'true';

    root.addEventListener(
      'wheel',
      (event) => {
        if (!desktop.matches) return;

        const media = root.querySelector('.product__media-wrapper');
        const info = root.querySelector('.product__info-wrapper');
        const hovered = event.target.closest('.product__media-wrapper, .product__info-wrapper');
        if (!media || !info || !hovered || !root.contains(hovered)) return;

        const delta = wheelDelta(event);
        if (!delta) return;

        const mediaState = columnState(media);
        const infoState = columnState(info);
        const onMedia = hovered === media;
        const goingDown = delta > 0;

        if (goingDown) {
          if (onMedia && !mediaState.atBottom) {
            event.preventDefault();
            scrollBy(media, delta);
            return;
          }
          if (!infoState.atBottom) {
            event.preventDefault();
            scrollBy(info, delta);
            return;
          }
          if (!mediaState.atBottom) {
            event.preventDefault();
            return;
          }
          return;
        }

        if (onMedia && !mediaState.atTop) {
          event.preventDefault();
          scrollBy(media, delta);
          return;
        }
        if (!infoState.atTop) {
          event.preventDefault();
          scrollBy(info, delta);
          return;
        }
        if (!mediaState.atTop) {
          event.preventDefault();
          return;
        }
      },
      { passive: false }
    );
  }

  function init() {
    document.querySelectorAll('product-info .product--split-scroll').forEach((product) => {
      bind(product.closest('product-info') || product);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
